import React from "react";

const styles = {
  veg: { border: "border-[#2E7D32]", fill: "bg-[#2E7D32]", label: "Veg", triangle: false },
  non_veg: { border: "border-[#6D3B22]", fill: "border-b-[8px] border-x-[5px] border-x-transparent border-b-[#6D3B22]", label: "Non-Veg", triangle: true },
  vegan: { label: "Vegan" },
};

export const FoodSymbol = ({ value, className = "", testId }) => {
  const symbol = styles[value];
  if (!symbol) return null;
  if (value === "vegan") {
    return (
      <span
        className={`relative inline-flex h-4 w-4 shrink-0 items-center ${className}`}
        data-testid={testId || "food-symbol-vegan"}
        title="Vegan"
        aria-label="Vegan"
      >
        <img
          src="https://customer-assets-agu9un31.emergentagent.net/job_premium-bazaar-112/artifacts/cknmlb0c_ic_vegan.png"
          alt="Vegan"
          className="absolute left-0 top-1/2 h-9 w-9 -translate-y-1/2 object-contain"
        />
      </span>
    );
  }
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1 ${className}`}
      data-testid={testId || `food-symbol-${value}`}
      title={symbol.label}
      aria-label={symbol.label}
    >
      <span className={`flex h-4 w-4 items-center justify-center border ${symbol.border}`}>
        <span className={symbol.triangle ? symbol.fill : `h-2 w-2 rounded-full ${symbol.fill}`} />
      </span>
    </span>
  );
};